import { Link as MaterialLink, LinkProps as MaterialLinkProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

export const LinkStyled = styled((props: MaterialLinkProps & { to?: string }) => {
  return (
    <MaterialLink component={RouterLink} {...props} />
  );
})(() => '');
